import axios from "axios";
import config from 'react-global-configuration';
//const { QueryTypes } = require('sequelize');
//import models from 


const options = [];

let res = async() =>{
    await axios.get(config.get('API_URL') + "/brandemi/get_state_values", {
        headers: {
            Authorization: ` ${localStorage.usertoken}`
        },
    })
    .then(data => {
        if (data) {
            data.map((values, index) => {
                options.push({
                    value: values.state_id,
                    label: values.state_name
                });
            })
            return options;
        } else {
            console.log('No valid data available');
        }
    })
    .catch(err => {
        console.log('error: ' + err)
    })
}

const sleep = ms =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

const optionsPerPage = 10;

const loadOptions = async (search, page) => {
  await sleep(1000);

  let filteredOptions;
  if (!search) {
    filteredOptions = res();
  } else {
    const searchLower = search.toLowerCase();

    filteredOptions = res().filter(({ label }) =>
      label.toLowerCase().includes(searchLower)
    );
  }

const hasMore = Math.ceil(filteredOptions.length / optionsPerPage) > page;
const slicedOptions = filteredOptions.slice(
    (page - 1) * optionsPerPage,
    page * optionsPerPage
);
console.log(slicedOptions);
return {
    options: slicedOptions,
    hasMore
};
};

export default loadOptions;

// const users = async () => {
//     await sequelize.query("SELECT `state_id`, `state_name` FROM `dw_state` AS `State` ORDER BY `State`.`state_id`", { type: QueryTypes.SELECT })
//         .then(data => {
//             if (data) {
//                 data.map((values, index) => {
//                     options.push({
//                         value: values.state_id,
//                         label: values.state_name
//                     });
//                 })
//             }
//             else {
//                 console.log('No valid data available');
//             }
//         })
//         .catch(err => {
//             console.log('error: ' + err)
//         })
// }
